import React from 'react';

function Mision () {
    return (
        <div class="text-center espacio">
            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_548/v1610580279/ARBAL/SIAR/desayuno2019.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
            <div class="row align-items-center espacio">
                <div class="col">
                Valor 1
                </div>
                <div class="col">
                Valor 2
                </div>
                <div class="col">
                Valor 3
                </div>
            </div>
        </div>
    )
}

export default Mision